<script>
import FDescription from "../information/FDescription.vue";
export default {
  components: { FDescription },
  methods: {},
  props: {
    optional: Boolean,
    optionalLabel: String,
    active: Boolean,
    focused: Boolean,
    disabled: Boolean,
    error: Boolean,
  },
  data: function () {
    return {};
  },
  computed: {},
};
</script>
    
<template>
  <div
    class="f-field"
    :class="[{ focused }, { disabled }, { active }, { error }]"
  >
    <div class="f-top" v-if="$slots.label">
      <div class="f-label">
        <slot name="label"></slot>
      </div>
      <div class="f-required" v-if="optional">
        {{ optionalLabel ? $vt(optionalLabel) : $vt("Optional") }}
      </div>
    </div>
    <div class="f-center">
      <slot name="content"></slot>
    </div>
    <div class="f-bottom" v-if="$slots.helper">
      <div class="f-helper">
        <f-description>
          <slot class="f-helper" name="helper"></slot>
        </f-description>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.f-field {
  width: 100%;

  .f-top {
    display: flex;
    align-items: baseline;

    .f-label {
      margin: 0 0 6px 4px;
      font-family: Lato;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #161615;
      display: flex;
      gap: 7px;
      align-items: baseline;
    }

    .f-required {
      margin-left: auto;
      font-family: Lato;
      font-size: 12px;
      font-weight: 400;
      color: #767675;
    }
  }

  .f-bottom {
    .f-helper {
      margin-top: 6px;
      margin-left: 4px;
    }
  }

  &.focused {
    .f-top {
      .f-label {
        color: #1890d3;
      }
    }
  }

  &.error {
    .f-top {
      .f-label {
        color: #d00e0e;
      }
    }

    .f-bottom {
      .f-helper {
        color: #d00e0e;
      }
    }
  }

  &.disabled {
    .f-top {
      .f-label {
        color: rgba(22, 22, 21, 0.25);
      }
    }

    .f-bottom {
      .f-helper {
        color: rgba(22, 22, 21, 0.25);
      }
    }
  }
}
.dark-mode {
  .f-field {
    .f-top {
      .f-label {
        color: var(--white-a75);
		font-weight: bold;
      }

      .f-required {
        color: var(--white-a50);
      }
    }

    &.focused {
      .f-top {
        .f-label {
          color: var(--navigation);
        }
      }
    }

    &.error {
      .f-top {
        .f-label {
          color: var(--negative);
        }
      }

      .f-bottom {
        .f-helper {
          color: var(--negative);
        }
        .f-description {
          color: var(--negative);
        }
      }
    }

    &.disabled {
      .f-top {
        .f-label {
          color: rgba(22, 22, 21, 0.25);
        }
      }

      .f-bottom {
        .f-helper {
          color: rgba(22, 22, 21, 0.25);
        }
      }
    }
  }
}
</style>